module.exports = __webpack_public_path__ + "images/rank_logo_dau-c4cb4e38f3.png";